module.exports = __webpack_public_path__ + "img/product_bg_new_01.79915a7.svg";